import React, { useEffect } from 'react';
import { Helmet } from 'react-helmet-async';
import Header from '../components/Header';
import Footer from '../components/Footer';

const MentionsLegales = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <>
      <Helmet>
        <title>Mentions Légales | validatedboat - Conseiller Nautique</title>
        <meta name="description" content="Mentions légales du site validatedboat.fr - Conseiller nautique indépendant à La Rochelle. Informations sur l'éditeur, l'hébergeur et la protection des données." />
        <meta name="robots" content="index, follow" />
        <link rel="canonical" href="https://validatedboat.fr/mentions-legales" />
      </Helmet>

      <div className="min-h-screen bg-[#1a1c1b]" data-testid="mentions-legales-page">
        <Header />
        
        <main className="pt-24 pb-16 px-5 md:px-10">
          <div className="max-w-4xl mx-auto">
            <h1 className="text-3xl md:text-4xl font-black text-[#d9fb06] uppercase mb-8" data-testid="mentions-title">
              Mentions Légales
            </h1>

            {/* Éditeur du site */}
            <section className="mb-10" data-testid="section-editeur">
              <h2 className="text-xl md:text-2xl font-bold text-[#dfddd6] mb-4 border-b border-[#3f4816] pb-2">
                1. Éditeur du site
              </h2>
              <div className="text-[#888680] space-y-2">
                <p><span className="text-[#dfddd6] font-semibold">Raison sociale :</span> validatedboat</p>
                <p><span className="text-[#dfddd6] font-semibold">Statut :</span> Micro-entreprise / Entrepreneur individuel</p>
                <p><span className="text-[#dfddd6] font-semibold">Siège social :</span> La Rochelle, 17000, France</p>
                <p><span className="text-[#dfddd6] font-semibold">SIRET :</span> 820 771 764 00017</p>
                <p><span className="text-[#dfddd6] font-semibold">Numéro de TVA :</span> Non assujetti (micro-entreprise)</p>
                <p><span className="text-[#dfddd6] font-semibold">Email :</span> contact@validatedboat.fr</p>
                <p><span className="text-[#dfddd6] font-semibold">Directeur de la publication :</span> Le gérant de validatedboat</p>
              </div>
            </section>

            {/* Hébergeur */}
            <section className="mb-10" data-testid="section-hebergeur">
              <h2 className="text-xl md:text-2xl font-bold text-[#dfddd6] mb-4 border-b border-[#3f4816] pb-2">
                2. Hébergeur
              </h2>
              <div className="text-[#888680] space-y-2">
                <p><span className="text-[#dfddd6] font-semibold">Nom :</span> Emergent Labs Inc.</p>
                <p><span className="text-[#dfddd6] font-semibold">Adresse :</span> San Francisco, CA, États-Unis</p>
                <p><span className="text-[#dfddd6] font-semibold">Site web :</span> <a href="https://emergent.sh" target="_blank" rel="noopener noreferrer" className="text-[#d9fb06] hover:underline">https://emergent.sh</a></p>
              </div>
            </section>

            {/* Propriété intellectuelle */}
            <section className="mb-10" data-testid="section-propriete">
              <h2 className="text-xl md:text-2xl font-bold text-[#dfddd6] mb-4 border-b border-[#3f4816] pb-2">
                3. Propriété intellectuelle
              </h2>
              <div className="text-[#888680] space-y-4">
                <p>
                  L'ensemble du contenu de ce site (textes, images, graphismes, logo, icônes, etc.) est la propriété exclusive de validatedboat, 
                  à l'exception des marques, logos ou contenus appartenant à d'autres sociétés partenaires ou auteurs.
                </p>
                <p>
                  Toute reproduction, distribution, modification, adaptation, retransmission ou publication, même partielle, 
                  de ces différents éléments est strictement interdite sans l'accord exprès par écrit de validatedboat.
                </p>
                <p>
                  Les images utilisées sur ce site proviennent de banques d'images libres de droits (Unsplash, Pexels) 
                  et sont utilisées conformément à leurs licences respectives.
                </p>
              </div>
            </section>

            {/* Protection des données personnelles */}
            <section className="mb-10" data-testid="section-donnees">
              <h2 className="text-xl md:text-2xl font-bold text-[#dfddd6] mb-4 border-b border-[#3f4816] pb-2">
                4. Protection des données personnelles (RGPD)
              </h2>
              <div className="text-[#888680] space-y-4">
                <h3 className="text-lg font-semibold text-[#dfddd6] mt-4">4.1 Responsable du traitement</h3>
                <p>
                  Le responsable du traitement des données personnelles est validatedboat, 
                  joignable à l'adresse email : contact@validatedboat.fr
                </p>

                <h3 className="text-lg font-semibold text-[#dfddd6] mt-4">4.2 Données collectées</h3>
                <p>Nous collectons les données suivantes :</p>
                <ul className="list-disc list-inside ml-4 space-y-1">
                  <li>Données de contact (nom, email, téléphone) lors de la prise de rendez-vous via Calendly</li>
                  <li>Informations sur votre projet nautique fournies lors des échanges</li>
                  <li>Données de navigation anonymisées à des fins statistiques</li>
                </ul>

                <h3 className="text-lg font-semibold text-[#dfddd6] mt-4">4.3 Finalité du traitement</h3>
                <p>Vos données sont utilisées pour :</p>
                <ul className="list-disc list-inside ml-4 space-y-1">
                  <li>Répondre à vos demandes de renseignements</li>
                  <li>Planifier et gérer les rendez-vous</li>
                  <li>Assurer le suivi de votre projet d'achat de bateau</li>
                  <li>Améliorer nos services</li>
                </ul>

                <h3 className="text-lg font-semibold text-[#dfddd6] mt-4">4.4 Base légale</h3>
                <p>
                  Le traitement de vos données repose sur votre consentement explicite lors de la prise de contact 
                  et sur l'exécution du contrat de prestation de services.
                </p>

                <h3 className="text-lg font-semibold text-[#dfddd6] mt-4">4.5 Durée de conservation</h3>
                <p>
                  Vos données personnelles sont conservées pendant une durée de 3 ans à compter du dernier contact, 
                  conformément aux recommandations de la CNIL.
                </p>

                <h3 className="text-lg font-semibold text-[#dfddd6] mt-4">4.6 Vos droits</h3>
                <p>Conformément au RGPD, vous disposez des droits suivants :</p>
                <ul className="list-disc list-inside ml-4 space-y-1">
                  <li><strong>Droit d'accès :</strong> obtenir une copie de vos données</li>
                  <li><strong>Droit de rectification :</strong> corriger vos données inexactes</li>
                  <li><strong>Droit à l'effacement :</strong> demander la suppression de vos données</li>
                  <li><strong>Droit à la limitation :</strong> limiter le traitement de vos données</li>
                  <li><strong>Droit à la portabilité :</strong> recevoir vos données dans un format structuré</li>
                  <li><strong>Droit d'opposition :</strong> vous opposer au traitement de vos données</li>
                </ul>
                <p className="mt-4">
                  Pour exercer ces droits, contactez-nous à : <a href="mailto:contact@validatedboat.fr" className="text-[#d9fb06] hover:underline">contact@validatedboat.fr</a>
                </p>
                <p>
                  En cas de litige, vous pouvez saisir la CNIL : <a href="https://www.cnil.fr" target="_blank" rel="noopener noreferrer" className="text-[#d9fb06] hover:underline">www.cnil.fr</a>
                </p>
              </div>
            </section>

            {/* Cookies */}
            <section className="mb-10" data-testid="section-cookies">
              <h2 className="text-xl md:text-2xl font-bold text-[#dfddd6] mb-4 border-b border-[#3f4816] pb-2">
                5. Cookies
              </h2>
              <div className="text-[#888680] space-y-4">
                <p>
                  Ce site utilise des cookies à des fins de mesure d'audience et d'amélioration de l'expérience utilisateur.
                </p>
                <h3 className="text-lg font-semibold text-[#dfddd6] mt-4">Types de cookies utilisés :</h3>
                <ul className="list-disc list-inside ml-4 space-y-1">
                  <li><strong>Cookies essentiels :</strong> nécessaires au fonctionnement du site</li>
                  <li><strong>Cookies analytiques :</strong> permettent de mesurer l'audience (PostHog)</li>
                  <li><strong>Cookies tiers :</strong> liés à l'intégration de Calendly pour la prise de rendez-vous</li>
                </ul>
                <p className="mt-4">
                  Vous pouvez configurer votre navigateur pour refuser les cookies. 
                  Cependant, certaines fonctionnalités du site pourraient ne plus être accessibles.
                </p>
              </div>
            </section>

            {/* Limitation de responsabilité */}
            <section className="mb-10" data-testid="section-responsabilite">
              <h2 className="text-xl md:text-2xl font-bold text-[#dfddd6] mb-4 border-b border-[#3f4816] pb-2">
                6. Limitation de responsabilité
              </h2>
              <div className="text-[#888680] space-y-4">
                <p>
                  Les informations contenues sur ce site sont aussi précises que possible et le site est périodiquement remis à jour. 
                  Toutefois, validatedboat ne peut garantir l'exactitude, la précision ou l'exhaustivité des informations mises à disposition.
                </p>
                <p>
                  validatedboat décline toute responsabilité pour toute imprécision, inexactitude ou omission portant sur des informations 
                  disponibles sur ce site.
                </p>
                <p>
                  Les conseils et informations fournis sur ce site, notamment dans la section blog, sont donnés à titre informatif 
                  et ne sauraient se substituer à l'avis d'un expert maritime ou à une expertise professionnelle.
                </p>
              </div>
            </section>

            {/* Liens hypertextes */}
            <section className="mb-10" data-testid="section-liens">
              <h2 className="text-xl md:text-2xl font-bold text-[#dfddd6] mb-4 border-b border-[#3f4816] pb-2">
                7. Liens hypertextes
              </h2>
              <div className="text-[#888680] space-y-4">
                <p>
                  Ce site peut contenir des liens hypertextes vers d'autres sites. 
                  validatedboat n'exerce aucun contrôle sur ces sites et décline toute responsabilité quant à leur contenu.
                </p>
                <p>
                  La création de liens hypertextes vers le site validatedboat.fr est autorisée sous réserve de ne pas porter atteinte 
                  à l'image de validatedboat et de ses services.
                </p>
              </div>
            </section>

            {/* Droit applicable */}
            <section className="mb-10" data-testid="section-droit">
              <h2 className="text-xl md:text-2xl font-bold text-[#dfddd6] mb-4 border-b border-[#3f4816] pb-2">
                8. Droit applicable et juridiction
              </h2>
              <div className="text-[#888680] space-y-4">
                <p>
                  Les présentes mentions légales sont régies par le droit français.
                </p>
                <p>
                  En cas de litige, et après échec de toute tentative de recherche d'une solution amiable, 
                  les tribunaux français seront seuls compétents pour connaître de ce litige.
                </p>
              </div>
            </section>

            {/* Mise à jour */}
            <section data-testid="section-maj">
              <h2 className="text-xl md:text-2xl font-bold text-[#dfddd6] mb-4 border-b border-[#3f4816] pb-2">
                9. Mise à jour des mentions légales
              </h2>
              <div className="text-[#888680]">
                <p>
                  Les présentes mentions légales peuvent être modifiées à tout moment. 
                  Nous vous invitons à les consulter régulièrement.
                </p>
                <p className="mt-4">
                  <span className="text-[#dfddd6] font-semibold">Dernière mise à jour :</span> Janvier 2026
                </p>
              </div>
            </section>

          </div>
        </main>

        <Footer />
      </div>
    </>
  );
};

export default MentionsLegales;
